<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Moje Konto - ZMIANA HASŁA</div>
          <div class="card-body text-center">
            <a :href="webLink" target="_blank">
              <img class="p-3" :src="logoSrc" alt="skp"
            /></a>
            <form
              action="#"
              method="POST"
              @submit.prevent="sendEmail"
              v-if="!emailSent"
            >
              <div class="form-group row">
                <label
                  for="licence"
                  class="col-md-4 col-form-label text-md-right"
                  >Nr licencji</label
                >
                <div class="col-md-5">
                  <input
                    id="licence"
                    type="number"
                    class="form-control"
                    name="licence"
                    required
                    autofocus
                    v-model="form.licence"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label text-md-right"
                  >E-mail</label
                >
                <div class="col-md-5">
                  <input
                    id="email"
                    type="email"
                    class="form-control"
                    name="email"
                    required
                    autocomplete="email"
                    v-model="form.email"
                  />
                </div>
              </div>
              <p v-if="errors.length" class="error offset-md-2"></p>
              <ul>
                <li
                  v-for="error in errors"
                  v-bind:key="error"
                  class="text-danger justify-content-md-start"
                  v-html="error"
                ></li>
              </ul>
              <div class="form-group row mb-10 justify-content-md-center">
                <div class="col-md-6">
                  <button type="submit" class="btn btn-success btn-block my-2">
                    Wyślij
                  </button>
                </div>
              </div>
              <div class="form-group row mb-10 justify-content-md-center">
                <div class="col-md-7">
                  <p>
                    Na podany adres e-mail otrzymasz wiadomość zawierającą link,
                    umożliwiający zmianę hasła dostępu do Twojego konta.
                    <br />Kliknij go i wprowadź hasło do logowania.
                  </p>
                </div>
              </div>
            </form>
            <div class="success" v-if="emailSent">
              Twoja prośba o zmianę hasła została wysłana. <br />Na podany adres
              e-mail otrzymasz wiadomość zawierającą link umożliwiający zmianę
              hasła. <br />Kliknij go i utwórz nowe hasło.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isTestAccountRegistered } from '../../shared/isTestAccountRegistered';

export default {
  name: 'ChangePassword',
  props: {
    logoSrc: {},
  },
  data() {
    return {
      form: {
        email: '',
        licence: '',
      },
      errors: [],
      emailSent: false,
      text: '',
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
    }),
    webLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/'
        : 'https://www.samozatrudnienie.pl/';
    },
    userable_type() {
      if (this.program === 'skp') {
        return isTestAccountRegistered(this.form.licence)
          ? 'App\\Models\\SkpClientTest'
          : 'App\\Models\\SkpClient';
      }

      return isTestAccountRegistered(this.form.licence)
        ? 'App\\Models\\SamClientTest'
        : 'App\\Models\\SamClient';
    },
  },
  beforeCreate: function () {
    document.body.className = 'login';
  },
  methods: {
    sendEmail() {
      this.errors = [];
      if (this.errors.length === 0) {
        axios
          .post('/password/email', {
            email: this.form.email,
            userable_id: this.form.licence,
            userable_type: this.userable_type,
            program: this.program,
          })
          .then((response) => {
            this.emailSent = true;
          })
          .catch((errors) => {
            let that = this;
            $.each(errors.response.data, function (key, value) {
              that.errors.push(value);
            });
          });
      }
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
